import { AuditEventSchema, paginatedResponseSchema } from '@gestion-permisos/contracts';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/api-context.js';
import { ADMIN_PAGE_SIZE } from './admin-api.js';

const AuditPageSchema = paginatedResponseSchema(AuditEventSchema);

/** Filtros de la auditoría, tal como los escribe el administrador (texto; sin convertir con `Date`). */
export interface AuditFilters {
  readonly entityType: string;
  readonly entityId: string;
  readonly actorId: string;
  readonly from: string;
  readonly to: string;
}

/** `GET /audit-events?…&pageSize=20`: cada filtro se envía solo si tiene valor. Lo valida la API (400). */
export function auditPath(filters: AuditFilters, page: number): string {
  const params = new URLSearchParams();
  for (const key of ['entityType', 'entityId', 'actorId', 'from', 'to'] as const) {
    const value = filters[key].trim();
    if (value !== '') params.set(key, value);
  }
  params.set('page', String(page));
  params.set('pageSize', String(ADMIN_PAGE_SIZE));
  return `/api/v1/audit-events?${params.toString()}`;
}

/** Una página de la auditoría (solo lectura; solo administradores: si no, 403). */
export function useAuditPage(filters: AuditFilters, page: number) {
  const api = useApi();
  const path = auditPath(filters, page);
  return useQuery({
    queryKey: ['admin', 'audit', path],
    queryFn: () => api.get(path, AuditPageSchema),
  });
}
